import { memo } from 'react';
import { useCalendarGridStore } from '../../store/calendar-grid.store';
import { CalendarColumnHeaderType } from '../../types';
import { EventRenderer } from './event-renderer';
import { OverlappingEvents } from './overlapping-events';

interface Props {
  columnId: string;
}

const ALLOWED_HEADER_TYPE_FOR_OVERLAPPING_EVENTS: CalendarColumnHeaderType[] = ['provider', 'operatory'];

const ColumnEventsComponent = ({ columnId }: Props) => {
  const columnInfo = useCalendarGridStore((s) => s.columnsById[columnId]);
  const { headerType } = useCalendarGridStore(['headerType']);

  const eventIds = columnInfo?.eventIds ?? [];

  if (!eventIds.length) return null;

  if (ALLOWED_HEADER_TYPE_FOR_OVERLAPPING_EVENTS.includes(headerType)) {
    return <OverlappingEvents eventIds={eventIds} />;
  }

  return eventIds.map((eventId) => <EventRenderer key={eventId} eventId={eventId} columnId={columnId} />);
};

export const ColumnEvents = memo(ColumnEventsComponent);
